/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';
import ElectroDatePicker from 'forms/components/inputs/ElectroDatePicker/ElectroDatePicker';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  form: TypeForm,
  contract: Object,
|} & TranslatorProps;

@translate()
@observer
export default class ExtendContractForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, contract, form }: TypeProps = this.props;

    const details: Array<*> = [
      [t('general:trading_account'), `${contract.account_name} ${contract.account_no}`],
      [t('general:contracts.labels.number'), contract.contract_number],
      [t('general:labels.po_number'), contract.billing_details.po_number],
      [
        t('general:labels.expected_end_date'),
        contract.er_expected_end_date && (
          <Moment
            key="er_expected_end_date"
            date={contract.er_expected_end_date}
            format="MMMM DD, YYYY"
          />
        ),
      ],
      [t('general:assets.rented_assets.abbrs.number_of'), contract.assets_count],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:contracts.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('extendAssets.assets')}
            heading={form.$('extendAssets').label}
            endpoint={`contracts/${contract.id}/asset-rental-extend`}
            enableSearch={true}
            searchKeys={['asset_number', 'manufacturer', 'model']}
            customResponse={(response: *) => response.assets}
            primaryLiteral={(item: Object) => {
              return `${item.asset_number}, ${item.manufacturer}, ${item.model}`;
            }}
          />
          <ActionDrawerBlock gutters={true} padding={true} heading={form.$('extendDetails').label}>
            <ElectroDatePicker
              field={form.$('extendDetails.endDate')}
              minDate={form.$('extendDetails.endDate').value}
            />
            <ElectroSelectWithOther
              field={form.$('extendDetails.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
              selectUp={true}
            />
            <ElectroTextField field={form.$('extendDetails.newPONumber')} />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.extend')} />
      </React.Fragment>
    );
  }
}
